module.exports = __webpack_public_path__ + "media/application/images/ui/kiwi-icon-3d0cfd282022ab24aae40fff0c1e3bdc.png";